module.exports = "<div ui-view></div>\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-error/template.html
// module id = ./pages/xo-error/template.html
// module chunks = 0